<template>
  <div>
    <van-tabs v-model="searchType"  sticky title-active-color="#4196FF" color="#4196FF">
      <van-tab :disabled="!isShow" title="小组" :name="1"></van-tab>
      <van-tab title="学生" :name="2"></van-tab>
      <!-- <van-tab title="结果概览" :name="3"></van-tab> -->
    </van-tabs>
    <Groups v-if="searchType===1"></Groups>
    <student v-if="searchType===2"></student>
    <!-- <overview v-if="searchType===3"></overview> -->
  </div>
</template>
<script>
import Groups from './Groups.vue'
import student from './student'
// import overview from './overview'
export default {
  name:'evaStudent',
  components: {
    Groups,
    student,
    // overview
  },
  data() {
    return {
      searchType: 1
    }
  },
  computed:{
    isShow(){
      return this.$store.state.evaluation.averageObj.HasGroup
    }
  },
  watch:{
    isShow(val){
      this.searchType===val?1:2
    }
  },
  created(){
    
  },
  methods:{
  }
}
</script>  
<style lang="less" scoped>
</style>